<template>
  <div class="footer">
    <div class="footer__container flex flex-col gap-8">
      <div class="order-2 sm:order-1 w-100p">
        <div class="flex flex-col-reverse sm:flex-row justify-between items-center gap-8">
          <span class="text-left w-full text-xl font-bold">
            {{ $t('footer.most_interested')}}
          </span>
          <div class="sm:-mr-4 sm:-my-2">
            <NuxtLink class="link" :to="footerLogoCncCenterLink" target="_blank">
              <DefaultIconsLogoCNC/>
            </NuxtLink>
          </div>
        </div>
        <ul class="footer__ul footer__ul--row">
          <li v-for="(item, index) in menuMostInterested" :key="`mi_${index}`">
            <NuxtLink class="link" :to="item.url" :target="item.target">
              {{ item.name }}
            </NuxtLink>
          </li>
        </ul>
        <div class="footer__center">
          <nav v-for="(item, index) in menuFooterCategories" :key="`mc_${index}`">
            <span>
              <NuxtLink class="link" :to="item.url" :target="item.target">
                {{ item.name }}
              </NuxtLink>
            </span>
            <ul v-if="item.items" class="footer__ul">
              <li v-for="(subitem, subindex) in item.items" :key="`mc_${index}_${subindex}`">
                <NuxtLink class="link" :to="subitem.url" :target="subitem.target">
                  {{ subitem.name }}
                </NuxtLink>
              </li>
            </ul>
          </nav>
        </div>
      </div>
      <div class="flex flex-col gap-8 mx-auto order-1 sm:order-2">
        <ul class="footer__ul footer__ul--row footer__ul--menu">
          <li v-for="(item, index) in menuFooterContacts" :key="`mct_${index}`">
            <NuxtLink class="link" :to="item.url" :target="item.target">
              {{ item.name }}
            </NuxtLink>
          </li>
        </ul>
        <div class="mx-auto">
          <DefaultSocialList
            :items="socialList"
          />
        </div>
      </div>
      <div class="footer__bottom w-full lg:w-8/12 order-3 mx-auto">
        <span class="">
          {{ $t('footer.copyright_year_from') }} - {{ getYear() }} <NuxtLink class="link" :to="footerCopyrightCncCenterLink" target="_blank">{{ $t('footer.copyright_cnc') }}</NuxtLink>
          <br>
          {{ $t('footer.copyright_text') }}
        </span>
        <ul class="footer__ul--row footer__ul--menu">
          <li v-for="(item, index) in menuFooterPrivacyMenu" :key="`mp_${index}`">
            <NuxtLink class="link" :to="item.url" :target="item.target">
              {{ item.name }}
            </NuxtLink>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import {useStaticMenuConfig} from "~/composables/useStaticMenuConfig"
import {MenuFooterMostInterestedConfig} from "~/config/MenuFooterMostInterestedConfig"
import {MenuFooterCategoriesConfig} from "~/config/MenuFooterCategoriesConfig"
import {MenuFooterContactsConfig} from "~/config/MenuFooterContactsConfig"
import {MenuFooterPrivacyMenuConfig} from "~/config/MenuFooterPrivacyMenuConfig"

const socialList = useSocialListConfig().getSocialList(true) || []

const menuMostInterested = useStaticMenuConfig(MenuFooterMostInterestedConfig).getConfig() || []
const menuFooterCategories = useStaticMenuConfig(MenuFooterCategoriesConfig).getConfig() || []
const menuFooterContacts = useStaticMenuConfig(MenuFooterContactsConfig).getConfig() || []
const menuFooterPrivacyMenu = useStaticMenuConfig(MenuFooterPrivacyMenuConfig).getConfig() || []

const footerCopyrightCncCenterLink = useRuntimeConfig().public.footerCopyrightCncCenterLink
const footerLogoCncCenterLink = useRuntimeConfig().public.footerLogoCncCenterLink

const getYear = () => {
  const now = new Date()
  return now.getFullYear()
}
</script>